import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Card, Table, Space, Pagination, Avatar, Button, Modal, Input, message } from 'antd'
import { getFollowUpUserListAPI, updateFollowUpUserNoLableNumAPI, deleteFollowUpUserAPI } from '@/apis/user'
import { checkMenu, checkLogin } from '@/utils'
// import { useParams } from 'react-router-dom'
const { Column } = Table

export default function FollowUpUserList() {
  const navigate = useNavigate()
  const location = useLocation()
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState()
  const [labelModel, setLabelModel] = useState(false) //  标签设置弹窗
  const [labelForm, setLabelForm] = useState({
    userId: undefined,
    nickName: undefined,
    allowNoLabelUserNum: 10,
  }) //  标签设置表单
  const [statusModel, setStatusModel] = useState(false) //  下架确认弹窗
  const [statusForm, setStatusForm] = useState({
    userId: undefined,
  }) //  下架确认弹窗

  //  获取跟进人列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const res = await getFollowUpUserListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.noLabelNum = item.customerNum - item.labelNum
          item.key = index + 1
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  //  分页变更、翻页
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  显示标签设置弹窗
  const showLabelModel = (user) => {
    console.log('%c [ user ]-48', 'font-size:13px; background:pink; color:#bf2c9f;', user)
    setLabelForm({
      ...labelForm,
      userId: user.userId,
      nickName: user.nickName,
      allowNoLabelUserNum: user.allowNoLabelUserNum || 0
    })
    setLabelModel(true)
  }
  // 关闭标签设置弹窗
  const closeLabelModel = () => {
    setLabelModel(false)
  }
  // 标签设置表单变更
  const changeLabel = (e) => {
    setLabelForm({
      ...labelForm,
      allowNoLabelUserNum: Number(e.target.value)
    })
  }
  // 标签设置提交
  const submitLabel = async () => {
    let params = {
      userId: labelForm.userId,
      allowNoLabelUserNum: labelForm.allowNoLabelUserNum,
    }
    const res = await updateFollowUpUserNoLableNumAPI(params)
    if (res.success === true) {
      message.success('设置成功')
      setLabelModel(false)
      fetchData()
    }
  }
  //  显示下架确认弹窗
  const showStatusModel = (user) => {
    setStatusForm({
      ...statusForm,
      userId: user.userId,
    })
    setStatusModel(true)
  }
  //  关闭下架确认弹窗
  const closeStatusModel = () => {
    setStatusModel(false)
  }
  // 下架确认提交
  const comfirmStatus = async () => {
    let params = {
      userId: statusForm.userId,
    }
    const res = await deleteFollowUpUserAPI(params)
    if (res.success === true) {
      message.success('下架成功')
      setStatusModel(false)
      fetchData()
    }
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
  }, [])
  return (
    <div>
      <div className="pageTitle">我的跟进人</div>
      <Card className="card">
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column
            title="头像/昵称"
            key="action"
            render={(_, record) => (
              <Space size="middle">
                <Avatar shape="square" size={24} draggable={false} src={record.avatarUrl + '?x-oss-process=image/resize,w_24,m_lfit'} />
                {record.nickName}
              </Space>
            )}
          />
          <Column title="电话" dataIndex="mobile" />
          <Column title="所属楼盘" dataIndex="houseName" />
          <Column title="当前认证身份" key="certType" render={(_, record) => record.certType === 1 && '销售BOSS'} />
          <Column title="客资数量" dataIndex="customerNum" />
          <Column title="已标记" dataIndex="labelNum" />
          <Column
            title="未标记"
            key="noLabelNum"
            render={(_, record) => (
              <Space size="middle">
                {record.noLabelNum}
                {record.noLabelNum >= record.allowNoLabelUserNum ? <span className="red">分客受限</span> : ''}
              </Space>
            )}
          />
          <Column
            title="允许未标记"
            key="allowNoLabelUserNum"
            render={(_, record) => (
              <Space size="middle">
                {record.allowNoLabelUserNum || 0}
                {record.status === 1 ? <Button type="link" className="color-576b95" onClick={() => showLabelModel(record)}>设置</Button> : ''}
              </Space>
            )}
          />
          <Column
            title="状态"
            key="action"
            render={(_, record) => (
              record.status === 1 ? (
                <Space size="middle">
                  <span className='gray'>正常</span>
                  <Button type="link" className="color-576b95" onClick={() => showStatusModel(record)}>下架</Button>
                </Space>
              ) : <span className='gray'>已下架（如需上架，重新认证）</span>
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
        <Modal title={labelForm.nickName} closable={false} open={labelModel} onOk={submitLabel} onCancel={closeLabelModel}>
          <div>允许未标记数量：</div>
          <Input type="number" placeholder="整数" defaultValue={labelForm.allowNoLabelUserNum || 0} count className="margin-top-16" onChange={changeLabel} />
        </Modal>
        <Modal title="提示" closable={false} open={statusModel} onOk={comfirmStatus} onCancel={closeStatusModel}>
          <p>下架后，跟进人将无法接收客资和查阅历史客资。如需上架，需重新进行认证。<span className="red">请谨慎操作！</span></p>
        </Modal>
      </Card>
    </div>
    
  )
}
